export default {
  isTrayEnabled: false,
  integrations: [],
  trayAccountId: undefined,
  trayUserId: undefined,
  trayUserToken: undefined,
  workflows: [],
  inProgressTrayInstance: { instance: undefined, loading: undefined, success: undefined },
  trayInstances: [],
  allowedConnectionsLimit: 1,
  status: { loading: undefined, success: undefined, error: undefined },
};
